export default __webpack_public_path__ + "static/media/t20.min.79ce7353.png";